import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { WMS1130_R01DetailDto, WMS1130_R01Dto, WMS1130_R01HeaderDto } from './Dto_WMS1130_R01';
import { WmsTransportDetailDto, WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";
import { WMS1130_R01Filter } from "./Store_WMS1130_R01";

const baseUrl = `${config.apiUrl}/WMS1130_R01`;

const getParams = (filter: Partial<WMS1130_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,
		customNm: filter.customNm || undefined,
		
		listLength: listLength || 0
	}
}

export const getWMS1130_R01List = async (option: string, params: Partial<WMS1130_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<WMS1130_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getWMS1130_R01AllCount = async (params: Partial<WMS1130_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getWMS1130_R01One = async (transportNo: string) => {
	const url = `${baseUrl}/one/${transportNo}`;
	return await getData<ResponseDto<WMS1130_R01HeaderDto>>(url);
}

export const getWMS1130_R01DetailList = async (transportNo: string, warehouseCd: string) => {
	const url = `${baseUrl}/detail/${transportNo}/${warehouseCd}`;

	return await getData<ResponseDto<WMS1130_R01DetailDto[]>>(url);
}

export const createWMS1130_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

export const postWMS1130_R01 = async (data: WMS1130_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<WMS1130_R01Dto, ResponseDto<WMS1130_R01Dto>>(url, data);
}

export const patchWMS1130_R01 = async (data: WMS1130_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<WMS1130_R01Dto, ResponseDto<WMS1130_R01Dto>>(url, data);
}

export const deleteWMS1130_R01 = async (transportNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			transportNo
		}
	});
}

export const downloadExcel_WMS1130_R01 = async (option: string, transportNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			transportNo
		}
	})
}
export const getPdfBlob_WMS1130_R01 = async (transportNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { transportNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};